// extracted by mini-css-extract-plugin
export default {"main":"EmptyData_main__nsER-"};